import { useMemo } from 'react';
import { rage, useObservable } from '~/rage';
import { WalletType } from '~/shared';
import { StageTypes, useLayoutSelector } from '../redux';
import { useBuy } from './useBuy';

const useShopPreview = () => {
	const activeStage = useLayoutSelector(
		(state) => state.tattooShop.activeStage,
	);
	const activeList = useLayoutSelector((state) => state.tattooShop.activeList);
	const activeListIndex = useLayoutSelector(
		(state) => state.tattooShop.activeListIndex,
	);
	const activeCategory = useLayoutSelector(
		(state) => state.tattooShop.activeCategory,
	);
	const ownedTattoos = useObservable(rage.tattooShop.getOwnedTattoos());
	const tattooDeletionPrice = useObservable(
		rage.tattooShop.getTattooDeletionPrice(),
	);
	const { handleBuy, handleDelete } = useBuy();

	const list = useMemo(() => {
		if (activeCategory === 'delete') {
			return ownedTattoos;
		}
		return activeList;
	}, [activeCategory, activeList, ownedTattoos]);

	const visible = useMemo(
		() => activeStage !== StageTypes.Category && activeListIndex !== null,
		[activeStage, activeListIndex],
	);

	const item = useMemo(
		() => list[activeListIndex || 0],
		[list, activeListIndex],
	);

	return {
		visible,
		name: item?.name,
		price: activeCategory === 'delete' ? tattooDeletionPrice : item?.price || 0,
		handlePayByCash: () =>
			activeCategory === 'delete'
				? handleDelete(WalletType.Cash)
				: handleBuy(WalletType.Cash),
		handlePayByCard: () =>
			activeCategory === 'delete'
				? handleDelete(WalletType.Bank)
				: handleBuy(WalletType.Bank),
	};
};

export { useShopPreview };
